import { Currency } from '../core/api/general/general.types';
import { VoucherBasketItem } from '../core/api/order/order.types';
import { analyticsService } from '../core/services';
import { VoucherType } from '../core/state/restaurant/restaurant.types';
import { ToCurrency } from '../weborder/BasketControl';

export const trackVoucherAdded = (newVoucher: VoucherBasketItem): void => {
  const voucherData = {
    amp_label: 'Voucher Applied',
    amp_voucherAmount: newVoucher.Amount,
    amp_voucherType: 'n/a',
    amp_voucherUsed: newVoucher.Name,
  };
  analyticsService.track(voucherData);
};

export const formatVoucherValue = (
  type: VoucherType,
  value: string,
  currency: Currency,
  languageCode: string,
  addPercentageSign = false,
): string =>
  type === 'PercentageDiscount'
    ? value + (addPercentageSign ? '%' : '')
    : ToCurrency(Number(value || 0), currency, languageCode);
